import { render } from "./BalPopover.vue?vue&type=template&id=887cde44&ts=true"
import script from "./BalPopover.vue?vue&type=script&lang=ts"
export * from "./BalPopover.vue?vue&type=script&lang=ts"

import "./BalPopover.vue?vue&type=style&index=0&id=887cde44&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__